import { ProductTypeEnum } from '@ecoflow/ef-device-core/src/constants';

/**
 * @desc 应用开发环境访问地址
 */
export enum Host {
    JT = '//localhost:3005',
    PD = '//localhost:3015',
}

/**
 * @desc 应用构建后访问地址
 */
const map: { [key: string]: string } = {
    [Host.JT]: process.env.MICRO_HOST_JT as string,
    [Host.PD]: process.env.MICRO_HOST_PD as string,
};

/**
 * @desc 产品映射应开发地址
 */
export const HOST_MAP: { [key: string]: string } = {
    [ProductTypeEnum.JT303]: Host.JT,
    [ProductTypeEnum.JT321]: Host.JT,
    [ProductTypeEnum.DC303]: Host.JT,
    [ProductTypeEnum.YJ751]: Host.PD,
};

export default function hostMap(host: string) {
    if (process.env.NODE_ENV === 'production') return map[host];

    return host;
}
